export const localCopy = {
  "en-GB": {
    "local.serverChanged":"Sign in again to load current information. Your account and settings are saved.",
    "local.error.logoutStorage":"Logout could not be saved on this phone. Please try again when connected.",
    "local.error.secureStorage": "The phone could not save your sign-in. Try reopening the app.",
    "local.error.rememberUnavailable": "Sign-in cannot be remembered on this phone right now.",
    "local.error.sessionRenewedRetry": "You are signed in again. Try the action again if you still want it.",

    "batch.serverUpdate": "This feature is not available yet.",
    "telemetry.title": "GPS and updates",
    "telemetry.description": "View updates, battery and recorded route for a selected period.",
    "telemetry.window.15": "15 min",
    "telemetry.window.60": "1 hour",
    "telemetry.window.360": "6 hours",
    "telemetry.window.1440": "24 hours",
    "telemetry.reports": "Position reports",
    "telemetry.validGps": "Valid GPS",
    "telemetry.gpsRate": "GPS success",
    "telemetry.empty": "No position reports were received in this time window.",
    "telemetry.typicalInterval": "Typical interval",
    "telemetry.longestGap": "Longest gap",
    "telemetry.latestAge": "Latest report age",
    "telemetry.regularity": "Regular intervals",
    "telemetry.delayedGaps": "Long reporting gaps",
    "telemetry.expectedInterval": "Compared with the latest requested interval of {seconds} seconds.",
    "telemetry.period": "Observed period",
    "telemetry.batteryChange": "Reported battery",
    "telemetry.seconds": "{value} sec",
    "telemetry.routeDistance": "Approx. GPS path",
    "telemetry.routeQuality": "{used} route sections shown · {ignored} sections with uncertain positions omitted",
    "telemetry.routeUnavailable": "At least two GPS positions are needed to show a route.",
    "telemetry.routeNote": "Lines connect recorded positions and may differ from the path taken.",
    "activity.title": "Device activity",
    "activity.description": "The latest activity values received directly from the tracker.",
    "activity.rolls": "Movement count",
    "activity.periodChange": "Change during the selected period",
    "activity.stepIncrease": "Step-counter increase",
    "activity.rollIncrease": "Movement-counter increase",
    "activity.counterReset": "The step counter reset during this period. The displayed total may be incomplete.",
    "activity.rawNote": "Device step-counter readings. These may differ from the app's GPS estimates.",
    "health.activeAlerts": "Device notices",
    "health.alert.batteryCritical": "Tracker battery is critically low",
    "health.alert.batteryLow": "Tracker battery is low",
    "health.alert.disconnected": "Tracker connection is currently interrupted",
    "health.alert.reportingDelayed": "The tracker updates less often than requested",
    "health.alert.activeNote": "This notice disappears when the tracker updates normally again.",
    "battery.good": "Battery level at last contact.",
    "battery.low": "Battery is low. Plan to charge the tracker soon.",
    "battery.critical": "Battery is critically low. Charge the tracker now to keep it available.",
    "battery.unavailable": "Battery level is not available yet.",
    "operation.title.position": "Contacting tracker",
    "operation.title.find": "Updating device",
    "operation.title.upload": "Updating device",
    "operation.step.request": "Request sent",
    "operation.step.waitReport": "Waiting for report",
    "operation.step.position": "Position available",
    "operation.step.server": "Request received",
    "operation.step.connection": "Sent to tracker",
    "operation.step.reply": "Tracker replied",
    "upload.title": "Update the tracker's GPS interval",
    "upload.description": "Choose how often the physical tracker should normally send a position report. A shorter interval can use more battery and mobile data.",
    "upload.liveNote": "Choose how often the tracker should send its position, then select Save.",
    "upload.currentRequest": "Latest requested interval",
    "upload.oneMinute": "Every minute",
    "upload.tenMinutes": "Every 10 minutes",
    "upload.confirm": "Change reporting to {interval}?",
    "upload.confirmFast": "Frequent updates may use more battery.",
    "upload.confirmNormal": "Choose ten minutes between updates.",
    "upload.apply": "Update device",
    "upload.cooldown": "Wait {seconds} seconds before changing the interval again.",
    "upload.lastRequest": "Latest interval request",
    "upload.replyNote": "A reply confirms the tracker received the request. The GPS summary shows the actual reporting pattern.",
    "upload.progress.sending": "Updating device…",
    "upload.progress.accepted": "Waiting for the tracker to reply…",
    "upload.progress.sent": "Waiting for the tracker to reply…",
    "upload.progress.replied": "The tracker accepted the change. Check new positions to see its updates.",
    "upload.progress.unconfirmed": "No reply received. Check the setting before trying again.",
    "upload.progress.failed": "Delivery could not be confirmed. Check the tracker before trying again.",
    "upload.progress.cancelled": "The view is closed. A change already sent may still take effect.",
    "feature.uploadIntervalDemoBody": "This is a preview. Sign in to change settings on your device.",
    "feature.openLiveUpload": "Sign in to Qtracker",
    "connection.autoRefresh": "Updates automatically about every 15 seconds while the app is open.",
    "connection.refreshing": "Updating data…",
    "connection.connected": "Connected at last update",
    "connection.disconnected": "No contact at last update",
    "connection.stale": "Connection status needs a new check",
    "connection.unavailable": "Connection status unavailable",
    "connection.contactAge": "Last tracker contact: {minutes} min ago",
    "connection.reportAge": "Updated {minutes} min. ago",
    "history.lastValid": "Last GPS position",
    "history.olderPosition": "The latest report has no usable GPS position. Showing an earlier valid report.",
    "history.timeNote": "The time shows when Qtracker received the position. The position itself may be older.",
    "history.title": "Position history",
    "history.description": "The latest 20 GPS positions. Times are shown in your local time.",
    "history.empty": "No valid GPS reports have been stored yet.",
    "history.expand": "Show all available positions",
    "history.collapse": "Show fewer positions",
    "history.reportedDetails": "Position details",
    "history.speed": "Speed",
    "history.direction": "Direction",
    "history.altitude": "Altitude",
    "history.satellites": "Satellites",
    "history.signal": "Mobile signal",
    "history.battery": "Battery",
    "history.rawDetailsNote": "Information from the tracker at the displayed position.",
    "statusEvents.lost": "Connection to Qtracker lost",
    "statusEvents.probableEmpty": "Battery probably empty — recharge to restore contact",
    "statusEvents.restored": "Tracker contact restored",
    "statusEvents.batteryRecovered": "Battery level recovered",
    "route.title": "Route history",
    "route.description": "Choose a date to view and play the route.",
    "route.date": "Route date",
    "route.previousDay": "Previous day",
    "route.nextDay": "Next day",
    "route.refresh": "Refresh route",
    "route.coverage": "{valid} GPS positions · {invalid} updates without a position",
    "route.emptyMap": "No stored GPS positions to show on the map for this date.",
    "route.previousPoint": "Previous point",
    "route.nextPoint": "Next point",
    "route.gap": "Positions are missing here. Playback continues at the next recorded location.",
    "route.estimatedConnection": "The line connects recorded positions and may differ from the path taken.",
    "route.estimatedLegend": "Light dashed lines connect points across missing GPS reports. They do not show a measured route. Distance and activity use recorded data only.",
    "route.walkingWarning": "Estimated walking route from Google Maps (beta). Paths and sidewalks may be missing.",
    "route.walkingDistance": "Estimated walking distance",
    "route.editProfile": "Stride length and weight",
    "route.profileHelp": "Enter stride length (20–200 cm) and weight (20–300 kg) to estimate steps and energy from GPS.",
    "route.applyProfile": "Apply to estimates",
    "route.profileApplied": "Activity estimates updated",
    "route.method": "Estimates use recorded movement compatible with walking. GPS drift, missing points and slow vehicle travel can affect the result. Calories include resting energy during the estimated walking time. A dash means there is not enough usable data.",
    "local.error.routeTooLarge": "This day contains too many reports to load safely. Please contact support.",
    "route.showDate": "Show date",
    "route.today": "Today",
    "route.loading": "Loading the stored route…",
    "route.empty": "No valid GPS positions were stored for this date.",
    "route.positions": "GPS positions",
    "route.distance": "GPS route",
    "route.estimatedSteps": "Estimated steps",
    "route.estimatedCalories": "Estimated calories",
    "route.activityTime": "Estimated activity",
    "route.averageSpeed": "Average movement speed",
    "route.minutes": "{count} min",
    "route.estimateNote": "Estimates from GPS walks using stride length {stride} cm and weight {weight} kg.",
    "route.play": "Replay route",
    "route.pause": "Pause",
    "route.continue": "Continue",
    "route.showEntire": "Show entire route",
    "route.playbackPosition": "Position {current} of {total} · {time}",
    "route.playbackMarker": "Route playback",
    "route.quality": "{count} interrupted or implausible segments are excluded from distance and activity calculations.",
    "find.description": "Ask the tracker to ring for about one minute.",
    "find.confirm": "Ring the device?",
    "find.confirmBody": "The device may make a loud sound for about one minute.",
    "find.ring": "Ring tracker",
    "find.found": "I've found it!",
    "find.cancel": "Cancel",
    "find.cooldown": "Wait {seconds} seconds before ringing again.",
    "find.lastRequest": "Latest ring request",
    "find.socketSent": "Sent",
    "find.reply": "Reply received from tracker",
    "find.verifySound": "Listen for the device to find it.",
    "find.progress.sending": "Sending one ring request…",
    "find.progress.accepted": "Waiting for the tracker to reply…",
    "find.progress.sent": "Waiting for the tracker to reply…",
    "find.progress.replied": "The tracker replied. Can you hear it ringing?",
    "find.progress.found": "Search finished. Sound stops on the device or when its ring period ends.",
    "find.progress.unconfirmed": "The device did not reply but may still be ringing. Listen for it before trying again.",
    "find.progress.failed": "Delivery could not be confirmed. Check the tracker before trying again.",
    "find.progress.cancelled": "The view is closed. The device may still be ringing.",
    "local.error.findCooldown": "A ring request was recently accepted. Wait one minute before trying again.",
    "local.error.featureUnavailable": "This feature is not available yet.",
    "deviceInfo.title": "Device information",
    "deviceInfo.readOnly": "Latest information received from the device. Select Refresh to load it again.",
    "deviceInfo.firmwareSource": "Device firmware version",
    "deviceInfo.sim": "SIM card ID",
    "deviceInfo.received": "Last updated",
    "deviceInfo.notReported": "Not available in the latest stored report",
    "deviceInfo.configuration": "Device settings",
    "deviceInfo.noDisplayFields": "No device information to show yet.",
    "deviceInfo.configurationNote": "Some settings cannot be read from the device.",
    "deviceInfo.serverUpdate": "Device information is not available yet.",
    "deviceName.title": "Tracker name",
    "deviceName.description": "Give the device a name that is easy to recognise.",
    "deviceName.input": "Tracker name",
    "deviceName.placeholder": "For example Mum's tracker",
    "deviceName.characters": "{count} of 40 characters",
    "deviceName.save": "Save name",
    "deviceName.saved": "Tracker name saved",
    "deviceName.updated": "Last changed",
    "deviceName.id": "Tracker ID",
    "account.signedInAs": "Signed in as",
    "position.progress.sending": "Sending one position request…",
    "position.progress.waiting": "Waiting for a new position…",
    "position.progress.waitingNoFix": "New tracker data received, but GPS is not ready. Still checking…",
    "position.progress.gps": "A GPS position was received. Open Position to view its location and time.",
    "position.progress.noFix": "The tracker sent new data, but no valid GPS position arrived during this check. Move it outdoors and try again.",
    "position.progress.noReport": "No new position was received. You can try again.",
    "position.progress.cancelled": "The view is closed. The tracker may still send a position.",
    "position.stopWaiting": "Stop waiting",
    "position.receivedWithoutGps": "The tracker is connected but has no GPS position. Try outdoors with a clear view of the sky.",
    "position.noReportYet": "No position received yet.",
    "map.title": "Tracker map",
    "map.markerTitle": "Last GPS position",
    "map.noGpsOverview": "Map overview — the latest report has no valid GPS position. You can browse the map; no tracker marker is shown.",
    "map.nativeOnly": "The map is unavailable here. Open the position in Google Maps.",
    "map.openOverview": "Open Google Maps overview (no tracker position)",
    "map.diagnosticTitle": "Map",
    "map.openQsmartApp": "Open the installed Qtracker app to view the map.",
    "map.diagnosticBody": "Map preview.",
    "map.loading": "Loading Google Maps…",
    "map.tilesLoading": "Loading the map…",
    "map.tilesStalled": "The map could not be displayed. Try Reload map or open the position in Google Maps.",
    "map.renderReported": "Is the map blank? Try Reload map.",
    "map.reload": "Reload map",
    "map.openExternal": "Open position in Google Maps",
    "map.openFailed": "Google Maps could not be opened. The position is shown below.",
    "map.observationNote": "The marker shows the tracker's last known position. Check the time to see how old it is.",
    "hardware.simulator": "Example",
    "hardware.physical": "My device",
    "hardware.mode": "My device",
    "hardware.connectBody": "Sign in to view your device's position, status and notifications.",
    "hardware.credentialsHelp": "Sign in with your Qtracker account.",
    "hardware.noDevices": "Waiting for device contact.",
    "local.error.hardwareAddress": "Enter a valid HTTPS address.",
    "local.error.rateLimited": "Too many sign-in attempts. Wait one minute before trying again.",
    "local.error.loginUnavailable": "Sign-in is temporarily unavailable. Please try again.",
    "local.error.commandCooldown": "A position request was just sent. Wait ten seconds before sending another.",
    "server.connectTitle": "Sign in to Qtracker",
    "server.connectBody": "Sign in to view your devices.",
    "server.mode": "Example data",
    "server.positionTab": "Position",
    "server.positionExplanation": "Last received position. Check the time to see how recent it is.",
    "server.noDataTitle": "Data unavailable",
    "server.statusTitle": "Status at last refresh",
    "server.pendingTitle": "Awaiting response: {count}",
    "server.viewAlarms": "View alarms",
    "server.latestEvent": "Latest event",
    "server.openEvents": "Open events",
    "server.stepsReported": "Reported steps",
    "server.filter.all": "All",
    "server.filter.pending": "Pending",
    "server.filter.acknowledged": "Handled",
    "server.otherEvent": "Event received",
    "server.eventDetails": "Show delivery details",
    "server.hideDetails": "Hide details",
    "server.mapUnavailable": "Map unavailable",
    "server.mapExplanation": "This preview shows coordinates only.",
    "server.noMeasurements": "No health measurements available",
    "server.measurementsExplanation": "Readings are unavailable here.",
    "server.designPreview": "Preview",
    "server.designExplanation": "View an app preview. You will be signed out when opening it.",
    "server.openDesign": "Sign out and preview",
    "local.open": "Connect tracker",
    "local.back": "Back to preview",
    "local.title": "Qtracker · preview",
    "local.simulation": "Example data",
    "local.description": "Preview without a connection to a real device.",
    "local.address": "Address",
    "local.credentialsHelp": "Sign in with the provided preview account.",
    "local.connection": "Preview connection",
    "local.loadedAt": "Last refreshed",
    "local.refresh": "Refresh data",
    "local.dataRefreshed": "Data updated",
    "local.acknowledgementSaved": "Marked as handled",
    "local.loading": "Loading",
    "local.noData": "Data is unavailable. Check the connection and refresh to try again.",
    "local.noDevices": "No device available in the preview yet.",
    "local.tracker": "Preview device",
    "local.connected": "Tracker connected at last refresh",
    "local.disconnected": "Tracker disconnected at last refresh",
    "local.noFix": "No valid GPS position available",
    "local.positionReceived": "Position received",
    "local.positionCaveat": "Last received position. It may be older than the time it was received.",
    "local.commandSent": "Waiting for a new position. Refresh to check whether it has arrived.",
    "local.latestEvents": "Latest events (up to 50)",
    "local.fall": "Fall alarm",
    "local.protocolAck": "Device replied",
    "local.push": "Phone notification",
    "local.pushNotAttempted": "The notification has not been sent.",
    "local.pushUnverified": "Receipt not confirmed",
    "local.caregiverAck": "Response",
    "local.logout": "Sign out",
    "local.logoutLocalOnly": "You are signed out here. We could not end your sign-in with Qtracker; it expires automatically within one hour.",
    "local.error.address": "This address cannot be used for this preview.",
    "local.error.credentials": "The email or password is incorrect.",
    "local.error.session": "Sign in again to continue.",
    "local.error.connection": "No connection to Qtracker. Check your internet connection. The app will try again automatically.",
    "local.error.deviceOffline": "The tracker cannot be reached. Try again when it is online.",
    "local.error.deviceMissing": "Access to this tracker is unavailable. Open My devices to choose another available tracker.",
    "local.error.invalidDeviceName": "Enter a tracker name from 1 to 40 characters.",
    "local.error.routeWindow": "Choose a valid date range of up to 31 days.",
    "local.error.server": "The action could not be confirmed. Refresh the view before trying again.",
    "local.error.response": "Could not load the information. Try again later.",
    "local.error.testServer": "The connection does not match the selected view. Check the address.",
    "local.error.cancelled": "The request was cancelled. Refresh or sign in again.",
  },
  "da-DK": {
    "local.serverChanged":"Log ind igen for at hente aktuelle oplysninger. Din konto og dine indstillinger er bevaret.",
    "local.error.logoutStorage":"Logud kunne ikke gemmes på telefonen. Prøv igen, når der er forbindelse.",
    "local.error.secureStorage": "Telefonen kunne ikke gemme dit login. Prøv at åbne appen igen.",
    "local.error.rememberUnavailable": "Login kan ikke huskes på denne telefon lige nu.",
    "local.error.sessionRenewedRetry": "Du er logget ind igen. Prøv handlingen igen, hvis du stadig ønsker den.",

    "batch.serverUpdate": "Funktionen er ikke tilgængelig endnu.",
    "telemetry.title": "GPS og opdateringer",
    "telemetry.description": "Se opdateringer, batteri og registreret rute i en valgt periode.",
    "telemetry.window.15": "15 min.",
    "telemetry.window.60": "1 time",
    "telemetry.window.360": "6 timer",
    "telemetry.window.1440": "24 timer",
    "telemetry.reports": "Positionsrapporter",
    "telemetry.validGps": "Gyldig GPS",
    "telemetry.gpsRate": "GPS-andel",
    "telemetry.empty": "Der er ikke modtaget positionsrapporter i dette tidsrum.",
    "telemetry.typicalInterval": "Typisk interval",
    "telemetry.longestGap": "Længste pause",
    "telemetry.latestAge": "Alder på seneste rapport",
    "telemetry.regularity": "Regelmæssige intervaller",
    "telemetry.delayedGaps": "Lange rapporteringspauser",
    "telemetry.expectedInterval": "Sammenlignet med det senest anmodede interval på {seconds} sekunder.",
    "telemetry.period": "Observeret periode",
    "telemetry.batteryChange": "Rapporteret batteri",
    "telemetry.seconds": "{value} sek.",
    "telemetry.routeDistance": "Ca. GPS-rute",
    "telemetry.routeQuality": "{used} rutestrækninger vist · {ignored} strækninger med usikker position udeladt",
    "telemetry.routeUnavailable": "Der skal mindst to GPS-positioner til at vise en rute.",
    "telemetry.routeNote": "Linjerne forbinder registrerede positioner og kan afvige fra den fulgte vej.",
    "activity.title": "Enhedens aktivitet",
    "activity.description": "De seneste aktivitetsværdier modtaget direkte fra trackeren.",
    "activity.rolls": "Bevægelsestal",
    "activity.periodChange": "Ændring i det valgte tidsrum",
    "activity.stepIncrease": "Stigning i skridttæller",
    "activity.rollIncrease": "Stigning i bevægelsestæller",
    "activity.counterReset": "Skridttælleren blev nulstillet i perioden. Det viste tal kan derfor være ufuldstændigt.",
    "activity.rawNote": "Tal fra enhedens skridttæller. De kan afvige fra appens GPS-estimater.",
    "health.activeAlerts": "Beskeder om enheden",
    "health.alert.batteryCritical": "Trackerens batteri er kritisk lavt",
    "health.alert.batteryLow": "Trackerens batteri er lavt",
    "health.alert.disconnected": "Forbindelsen til trackeren er afbrudt lige nu",
    "health.alert.reportingDelayed": "Trackeren opdaterer sjældnere end ønsket",
    "health.alert.activeNote": "Beskeden forsvinder, når trackeren opdaterer normalt igen.",
    "battery.good": "Batteriniveau ved seneste kontakt.",
    "battery.low": "Batteriet er lavt. Planlæg opladning af trackeren snart.",
    "battery.critical": "Batteriet er kritisk lavt. Oplad trackeren nu for at holde den tilgængelig.",
    "battery.unavailable": "Batteriniveau er ikke tilgængeligt endnu.",
    "operation.title.position": "Kontakter tracker",
    "operation.title.find": "Opdaterer enhed",
    "operation.title.upload": "Opdaterer enhed",
    "operation.step.request": "Anmodning sendt",
    "operation.step.waitReport": "Venter på rapport",
    "operation.step.position": "Position tilgængelig",
    "operation.step.server": "Anmodning modtaget",
    "operation.step.connection": "Sendt til tracker",
    "operation.step.reply": "Svar fra tracker",
    "upload.title": "Opdater trackerens GPS-interval",
    "upload.description": "Vælg, hvor ofte den fysiske tracker normalt skal sende en positionsrapport. Et kortere interval kan bruge mere batteri og mobildata.",
    "upload.liveNote": "Vælg, hvor ofte trackeren skal sende sin position, og tryk Gem.",
    "upload.currentRequest": "Seneste anmodede interval",
    "upload.oneMinute": "Hvert minut",
    "upload.tenMinutes": "Hvert 10. minut",
    "upload.confirm": "Skift rapporteringen til {interval}?",
    "upload.confirmFast": "Hyppige opdateringer kan bruge mere batteri.",
    "upload.confirmNormal": "Vælg ti minutter mellem opdateringer.",
    "upload.apply": "Opdater enhed",
    "upload.cooldown": "Vent {seconds} sekunder, før du ændrer intervallet igen.",
    "upload.lastRequest": "Seneste intervalanmodning",
    "upload.replyNote": "Et svar bekræfter, at trackeren modtog anmodningen. GPS-oversigten viser det faktiske rapporteringsmønster.",
    "upload.progress.sending": "Opdaterer enhed…",
    "upload.progress.accepted": "Venter på svar fra trackeren…",
    "upload.progress.sent": "Venter på svar fra trackeren…",
    "upload.progress.replied": "Trackeren har accepteret ændringen. Se de nye positioner for at følge opdateringerne.",
    "upload.progress.unconfirmed": "Intet svar modtaget. Kontrollér indstillingen, før du prøver igen.",
    "upload.progress.failed": "Leveringen kunne ikke bekræftes. Kontrollér trackeren, før du prøver igen.",
    "upload.progress.cancelled": "Visningen er lukket. En allerede sendt ændring kan stadig blive udført.",
    "feature.uploadIntervalDemoBody": "Dette er en eksempelvisning. Log ind for at ændre indstillinger på din enhed.",
    "feature.openLiveUpload": "Log ind på Qtracker",
    "connection.autoRefresh": "Opdaterer automatisk cirka hvert 15. sekund, mens appen er åben.",
    "connection.refreshing": "Opdaterer data…",
    "connection.connected": "Forbundet ved seneste opdatering",
    "connection.disconnected": "Ingen kontakt ved seneste opdatering",
    "connection.stale": "Forbindelsesstatus skal opdateres",
    "connection.unavailable": "Forbindelsesstatus er ikke tilgængelig",
    "connection.contactAge": "Seneste kontakt med trackeren: {minutes} min siden",
    "connection.reportAge": "Opdateret for {minutes} min. siden",
    "history.lastValid": "Seneste GPS-position",
    "history.olderPosition": "Den seneste rapport har ingen brugbar GPS-position. Her vises en tidligere gyldig rapport.",
    "history.timeNote": "Tidspunktet viser, hvornår Qtracker modtog positionen. Selve positionen kan være ældre.",
    "history.title": "Positionshistorik",
    "history.description": "De seneste 20 GPS-positioner. Tidspunkter vises i din lokale tid.",
    "history.empty": "Der er endnu ikke gemt gyldige GPS-rapporter.",
    "history.expand": "Vis alle tilgængelige positioner",
    "history.collapse": "Vis færre positioner",
    "history.reportedDetails": "Positionsoplysninger",
    "history.speed": "Fart",
    "history.direction": "Retning",
    "history.altitude": "Højde",
    "history.satellites": "Satellitter",
    "history.signal": "Mobilsignal",
    "history.battery": "Batteri",
    "history.rawDetailsNote": "Oplysninger fra trackeren ved den viste position.",
    "statusEvents.lost": "Forbindelsen til Qtracker er mistet",
    "statusEvents.probableEmpty": "Sandsynligvis tomt batteri — oplad for at få forbindelse igen",
    "statusEvents.restored": "Forbindelsen til trackeren er tilbage",
    "statusEvents.batteryRecovered": "Batteriniveauet er normalt igen",
    "route.title": "Rutehistorik",
    "route.description": "Vælg en dato for at se og afspille ruten.",
    "route.date": "Dato for ruten",
    "route.previousDay": "Forrige dag",
    "route.nextDay": "Næste dag",
    "route.refresh": "Opdater rute",
    "route.coverage": "{valid} GPS-positioner · {invalid} opdateringer uden position",
    "route.emptyMap": "Ingen gemte GPS-positioner at vise på kortet for denne dato.",
    "route.previousPoint": "Forrige punkt",
    "route.nextPoint": "Næste punkt",
    "route.gap": "Der mangler positioner her. Afspilningen fortsætter ved næste registrerede sted.",
    "route.estimatedConnection": "Linjen forbinder de registrerede positioner og kan afvige fra den fulgte vej.",
    "route.estimatedLegend": "Lyse stiplede linjer forbinder punkter over manglende GPS-rapporter. De viser ikke en målt rute. Distance og aktivitet bruger kun registrerede data.",
    "route.walkingWarning": "Beregnet gangrute fra Google Maps (beta). Stier og fortove kan mangle.",
    "route.walkingDistance": "Estimeret gangdistance",
    "route.editProfile": "Skridtlængde og vægt",
    "route.profileHelp": "Indtast skridtlængde (20–200 cm) og vægt (20–300 kg) for at beregne skridt og energi fra GPS.",
    "route.applyProfile": "Anvend i beregninger",
    "route.profileApplied": "Aktivitetsestimater opdateret",
    "route.method": "Estimaterne bruger registreret bevægelse, der passer med gang. GPS-unøjagtighed, manglende punkter og langsom bilkørsel kan påvirke resultatet. Kalorier inkluderer hvileforbruget under den estimerede gangtid. En streg betyder, at der mangler brugbare data.",
    "local.error.routeTooLarge": "Denne dag indeholder for mange rapporter til sikker indlæsning. Kontakt support.",
    "route.showDate": "Vis dato",
    "route.today": "I dag",
    "route.loading": "Indlæser den gemte rute…",
    "route.empty": "Der blev ikke gemt gyldige GPS-positioner på denne dato.",
    "route.positions": "GPS-positioner",
    "route.distance": "GPS-rute",
    "route.estimatedSteps": "Estimerede skridt",
    "route.estimatedCalories": "Estimerede kalorier",
    "route.activityTime": "Estimeret aktivitet",
    "route.averageSpeed": "Gennemsnitlig bevægelsesfart",
    "route.minutes": "{count} min.",
    "route.estimateNote": "Vejledende beregning fra gåture med GPS, skridtlængde {stride} cm og vægt {weight} kg.",
    "route.play": "Afspil rute",
    "route.pause": "Pause",
    "route.continue": "Fortsæt",
    "route.showEntire": "Vis hele ruten",
    "route.playbackPosition": "Position {current} af {total} · {time}",
    "route.playbackMarker": "Ruteafspilning",
    "route.quality": "{count} afbrudte eller usandsynlige strækninger er udeladt af distance og aktivitet.",
    "find.description": "Bed trackeren om at ringe i cirka ét minut.",
    "find.confirm": "Lad enheden ringe?",
    "find.confirmBody": "Enheden kan afgive en høj lyd i cirka ét minut.",
    "find.ring": "Lad trackeren ringe",
    "find.found": "Jeg har fundet den!",
    "find.cancel": "Annuller",
    "find.cooldown": "Vent {seconds} sekunder, før du starter ringning igen.",
    "find.lastRequest": "Seneste anmodning om ringning",
    "find.socketSent": "Sendt",
    "find.reply": "Svar modtaget fra trackeren",
    "find.verifySound": "Lyt efter enheden for at finde den.",
    "find.progress.sending": "Sender én anmodning om ringning…",
    "find.progress.accepted": "Venter på svar fra trackeren…",
    "find.progress.sent": "Venter på svar fra trackeren…",
    "find.progress.replied": "Trackeren har svaret. Kan du høre den ringe?",
    "find.progress.found": "Søgningen er afsluttet. Lyden stopper på enheden eller efter dens ringetid.",
    "find.progress.unconfirmed": "Enheden svarede ikke, men kan stadig ringe. Lyt efter den, før du prøver igen.",
    "find.progress.failed": "Leveringen kunne ikke bekræftes. Kontrollér trackeren, før du prøver igen.",
    "find.progress.cancelled": "Visningen er lukket. Lyden kan stadig fortsætte på enheden.",
    "local.error.findCooldown": "En anmodning om ringning er netop accepteret. Vent ét minut, før du prøver igen.",
    "local.error.featureUnavailable": "Funktionen er ikke tilgængelig endnu.",
    "deviceInfo.title": "Enhedens oplysninger",
    "deviceInfo.readOnly": "Senest modtagne oplysninger fra enheden. Tryk Opdatér for at hente dem igen.",
    "deviceInfo.firmwareSource": "Enhedens firmwareversion",
    "deviceInfo.sim": "SIM-kortets ID",
    "deviceInfo.received": "Senest opdateret",
    "deviceInfo.notReported": "Ikke tilgængelig i seneste gemte rapport",
    "deviceInfo.configuration": "Enhedens indstillinger",
    "deviceInfo.noDisplayFields": "Ingen oplysninger at vise fra enheden endnu.",
    "deviceInfo.configurationNote": "Nogle indstillinger kan ikke aflæses fra enheden.",
    "deviceInfo.serverUpdate": "Enhedens oplysninger er ikke tilgængelige endnu.",
    "deviceName.title": "Trackerens navn",
    "deviceName.description": "Giv enheden et navn, som er let at genkende.",
    "deviceName.input": "Trackerens navn",
    "deviceName.placeholder": "For eksempel Mors tracker",
    "deviceName.characters": "{count} af 40 tegn",
    "deviceName.save": "Gem navn",
    "deviceName.saved": "Trackerens navn er gemt",
    "deviceName.updated": "Senest ændret",
    "deviceName.id": "Tracker-id",
    "account.signedInAs": "Logget ind som",
    "position.progress.sending": "Sender én positionsanmodning…",
    "position.progress.waiting": "Venter på en ny position…",
    "position.progress.waitingNoFix": "Nye trackerdata er modtaget, men GPS er ikke klar. Appen tjekker videre…",
    "position.progress.gps": "En GPS-position er modtaget. Åbn Position for at se placering og tidspunkt.",
    "position.progress.noFix": "Trackeren sendte nye data, men der kom ingen gyldig GPS-position under kontrollen. Tag den udendørs, og prøv igen.",
    "position.progress.noReport": "Vi modtog ingen ny position. Du kan prøve igen.",
    "position.progress.cancelled": "Visningen er lukket. Trackeren kan stadig sende en position.",
    "position.stopWaiting": "Luk ventetid",
    "position.receivedWithoutGps": "Trackeren har kontakt, men mangler GPS-position. Prøv udendørs med frit udsyn til himlen.",
    "position.noReportYet": "Ingen position modtaget endnu.",
    "map.title": "Tracker på kort",
    "map.markerTitle": "Seneste GPS-position",
    "map.noGpsOverview": "Kortoversigt — den seneste rapport har ingen gyldig GPS-position. Du kan bruge kortet; der vises ingen trackermarkør.",
    "map.nativeOnly": "Kortet er ikke tilgængeligt her. Åbn positionen i Google Maps.",
    "map.openOverview": "Åbn Google Maps-oversigt (uden trackerposition)",
    "map.diagnosticTitle": "Kort",
    "map.openQsmartApp": "Åbn den installerede Qtracker-app for at se kortet.",
    "map.diagnosticBody": "Eksempel på kortvisning.",
    "map.loading": "Indlæser Google Maps…",
    "map.tilesLoading": "Indlæser kortet…",
    "map.tilesStalled": "Kortet kunne ikke vises. Prøv Genindlæs kort, eller åbn positionen i Google Maps.",
    "map.renderReported": "Er kortet tomt? Prøv Genindlæs kort.",
    "map.reload": "Genindlæs kort",
    "map.openExternal": "Åbn position i Google Maps",
    "map.openFailed": "Google Maps kunne ikke åbnes. Positionen vises nedenfor.",
    "map.observationNote": "Markøren viser trackerens seneste kendte position. Se tidspunktet for positionens alder.",
    "hardware.simulator": "Eksempel",
    "hardware.physical": "Min enhed",
    "hardware.mode": "Min enhed",
    "hardware.connectBody": "Log ind for at se din enheds position, status og beskeder.",
    "hardware.credentialsHelp": "Log ind med din Qtracker-konto.",
    "hardware.noDevices": "Venter på kontakt til enheden.",
    "local.error.hardwareAddress": "Indtast en gyldig HTTPS-adresse.",
    "local.error.rateLimited": "For mange loginforsøg. Vent ét minut, før du prøver igen.",
    "local.error.loginUnavailable": "Login er midlertidigt utilgængeligt. Prøv igen.",
    "local.error.commandCooldown": "Der er lige sendt en positionsanmodning. Vent ti sekunder, før du sender en ny.",
    "server.connectTitle": "Log ind på Qtracker",
    "server.connectBody": "Log ind for at se dine enheder.",
    "server.mode": "Eksempeldata",
    "server.positionTab": "Position",
    "server.positionExplanation": "Senest modtagne position. Se tidspunktet for at vurdere, hvor ny den er.",
    "server.noDataTitle": "Data er ikke tilgængelige",
    "server.statusTitle": "Status ved seneste opdatering",
    "server.pendingTitle": "Afventer håndtering: {count}",
    "server.viewAlarms": "Se alarmer",
    "server.latestEvent": "Seneste hændelse",
    "server.openEvents": "Åbn hændelser",
    "server.stepsReported": "Rapporterede skridt",
    "server.filter.all": "Alle",
    "server.filter.pending": "Afventer",
    "server.filter.acknowledged": "Håndterede",
    "server.otherEvent": "Hændelse modtaget",
    "server.eventDetails": "Vis leveringsoplysninger",
    "server.hideDetails": "Skjul oplysninger",
    "server.mapUnavailable": "Kort er ikke tilgængeligt",
    "server.mapExplanation": "Denne eksempelvisning viser kun koordinater.",
    "server.noMeasurements": "Ingen sundhedsmålinger tilgængelige",
    "server.measurementsExplanation": "Målinger er ikke tilgængelige her.",
    "server.designPreview": "Eksempelvisning",
    "server.designExplanation": "Se et eksempel på appen. Du bliver logget ud, når du åbner eksemplet.",
    "server.openDesign": "Log ud og se eksempel",
    "local.open": "Forbind tracker",
    "local.back": "Tilbage til eksempel",
    "local.title": "Qtracker · eksempel",
    "local.simulation": "Eksempeldata",
    "local.description": "Eksempel uden forbindelse til en rigtig enhed.",
    "local.address": "Adresse",
    "local.credentialsHelp": "Log ind med den oplyste eksempelkonto.",
    "local.connection": "Eksempelforbindelse",
    "local.loadedAt": "Senest opdateret",
    "local.refresh": "Opdater data",
    "local.dataRefreshed": "Data er opdateret",
    "local.acknowledgementSaved": "Markeret som håndteret",
    "local.loading": "Indlæser",
    "local.noData": "Data er ikke tilgængelige. Kontrollér forbindelsen, og tryk på Opdater data for at prøve igen.",
    "local.noDevices": "Ingen enhed tilgængelig i eksemplet endnu.",
    "local.tracker": "Eksempelenhed",
    "local.connected": "Trackeren var tilsluttet ved seneste opdatering",
    "local.disconnected": "Trackeren var afbrudt ved seneste opdatering",
    "local.noFix": "Ingen gyldig GPS-position tilgængelig",
    "local.positionReceived": "Position modtaget",
    "local.positionCaveat": "Senest modtagne position. Positionen kan være ældre end modtagelsestidspunktet.",
    "local.commandSent": "Venter på en ny position. Opdatér for at se, om den er modtaget.",
    "local.latestEvents": "Seneste hændelser (højst 50)",
    "local.fall": "Faldalarm",
    "local.protocolAck": "Enheden har svaret",
    "local.push": "Notifikation på telefon",
    "local.pushNotAttempted": "Beskeden er ikke sendt.",
    "local.pushUnverified": "Modtagelse er ikke bekræftet",
    "local.caregiverAck": "Håndtering",
    "local.logout": "Log ud",
    "local.logoutLocalOnly": "Du er logget ud her. Vi kunne ikke afslutte dit login hos Qtracker; det udløber automatisk inden for en time.",
    "local.error.address": "Adressen kan ikke bruges til denne eksempelvisning.",
    "local.error.credentials": "E-mail eller adgangskode er forkert.",
    "local.error.session": "Log ind igen for at fortsætte.",
    "local.error.connection": "Ingen forbindelse til Qtracker. Kontrollér din internetforbindelse. Appen prøver automatisk igen.",
    "local.error.deviceOffline": "Der er ingen kontakt til trackeren. Prøv igen, når den er online.",
    "local.error.deviceMissing": "Du har ikke længere adgang til denne tracker. Åbn Mine enheder for at vælge en anden tilgængelig tracker.",
    "local.error.invalidDeviceName": "Skriv et trackernavn på 1 til 40 tegn.",
    "local.error.routeWindow": "Vælg et gyldigt tidsrum på højst 31 dage.",
    "local.error.server": "Handlingen kunne ikke bekræftes. Opdatér visningen, før du prøver igen.",
    "local.error.response": "Oplysningerne kunne ikke hentes. Prøv igen senere.",
    "local.error.testServer": "Forbindelsen passer ikke til den valgte visning. Kontrollér adressen.",
    "local.error.cancelled": "Anmodningen blev afbrudt. Opdater eller log ind igen.",
  },
};
